import { Component, Input } from '@angular/core';
import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { DocumentTemplateModel } from 'src/app/core/models/document/document-template-model';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { CategoryModel } from 'src/app/core/models/document/category-model';
import { CategorySearchModel } from 'src/app/core/models/document/category-search-model';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { ExploreService } from 'src/app/core/services/list-services/explore.service';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { AccountingConfigurationListConfig } from '../../list-views/accounting-configurations-list/accounting-configurations-list.config';
import { DocumentTemplatesEditListConfig } from './document-templates-edit-list.config';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { SourceObjectTypeEnum } from 'src/app/core/enums/accounting/source-object-type-enum';
import { TargetObjectTypeEnum } from 'src/app/core/enums/accounting/target-object-type-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { AccountingObjectMappingModel } from 'src/app/core/models/accounting/accounting-object-mapping.model';
import Swal from 'sweetalert2';
import { DocumentModel } from 'src/app/core/models/document/document-model';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { CustomFieldGroupModel } from 'src/app/core/models/myfile/custom-field-group.model';
import { CustomFieldModel } from 'src/app/core/models/document/custom-field-model';
import { DataType } from 'src/app/core/models/document/custom-field-base-model';

@Component({
  selector: 'app-document-templates-edit-modal',
  templateUrl: './document-templates-edit-modal.component.html',
  styleUrls: ['./document-templates-edit-modal.component.scss']
})
export class DocumentTemplatesEditModalComponent extends BaseModalWithProfilePhotoComponent {
  @Input() public override model: DocumentTemplateModel = new DocumentTemplateModel;

  categoryData$!: Observable<CategoryModel[]>;
  categoryOptions: { value: string, selectedText: string, dropdownText: string }[] = [];
  listedCategories: any[] = [];
  searchTerm: string | undefined;
  searchTerm$ = new Subject<string>();
  isCategoriesListOpen: boolean = false;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  //Current List variables 
  protected listItems: any;
  protected listItemsLoading = false;
  protected isLoadingVal: boolean = false;
  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();
  checkedValGet: any[] = [];
  pointerToOldEnableLineIndex: any;
  entityTypeId: EntityTypeEnum = EntityTypeEnum.Blog;
  defaultText: string = 'No File Selected'
  constructor(
    protected exploreService: ExploreService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
    this.categoryData$ = exploreService.categories$;
  }

  rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.EnableDisable:
        console.log(rowAction)
        if (rowAction.index !== this.tableConfig.activeInputFieldIndex) {
          if (this.pointerToOldEnableLineIndex) {
            this.pointerToOldEnableLineIndex.enableInLineEditing = 0;
          }
          this.pointerToOldEnableLineIndex = rowAction.model;
          this.tableConfig.activeInputFieldIndex = rowAction.index;
          rowAction.model.enableInLineEditing = 1;
        } else {
          rowAction.model.enableInLineEditing = 0;
          this.listItems[rowAction.index!] = rowAction.model;
          this.tableConfig.activeInputFieldIndex = undefined;
        }
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        Swal.fire({
          title: $localize`:@@:Delete Custom Field`,
          text: $localize`:@@:Are you sure you want to delete this field?`,
          icon: 'warning',
          color: 'var(--vz-body-color)',
          background: 'var(--vz-body-bg)',
          showCancelButton: true,
          confirmButtonColor: 'rgb(3, 142, 220)',
          cancelButtonColor: 'rgb(243, 78, 78)',
          confirmButtonText: $localize`:@@:Yes, Delete`,
          cancelButtonText: $localize`:@@:Cancel`,
        }).then(result => {
          if (result && result.isConfirmed) {
            this.listItems.splice(rowAction.index, 1);
            this.tableConfig.activeInputFieldIndex = undefined;
            this.model.customFields = this.listItems;
          }
        });
        break;

    }
  }

  uploadFile(event: any) {
    var file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result != undefined) {
          this.model.document = new DocumentModel();
          this.model.document.fileName = file.name;
          this.model.document.fileSize = file.size;
          this.model.document.fileType = file.type;
          this.model.document.fileExt = file.name.split('.')[file.name.split('.').length -1]
          this.model.document.base64FileString = reader.result.toString().split(',')[1];
        }
      };
    }
  }

  buttonActionSelected(buttonAction: any): void {
    switch (buttonAction) {
      case ButtonIdEnum.CreateNew:
        if (this.tableConfig.activeInputFieldIndex === undefined) {
          if (this.pointerToOldEnableLineIndex) {
            this.pointerToOldEnableLineIndex.enableInLineEditing = 0;
          }
          this.listItems.unshift(new CustomFieldModel('', 0, DataType.Text, '', '', '', ''));
          this.listItems[0].enableInLineEditing = 1;
          this.tableConfig.activeInputFieldIndex = 0;
        }
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel): void {
    throw new Error('Method not implemented.');
  }

  protected searchPlaceHolderText: string = ''; //extends BaseModalWithProfilePhotoComponent {

  override ngOnInit(): void {
    if (this.model.id == undefined) {
      this.newModel = true;
    }

    if(this.model.document == undefined){
      this.model.document = new DocumentModel(); 
    }

    this.searchTerm$.subscribe(search => {
      if (search != undefined) {
        this.searchTerm = search;
      }
    });

    const subscr3 = this.categoryData$.subscribe((categories: any[]) => {
      this.categoryOptions = [];
      categories.forEach(category => {
        if (category.id) {
          this.categoryOptions.push({ value: category.id, selectedText: category.name, dropdownText: category.name },)
        }
      });
    });

    this.tableConfig = new DocumentTemplatesEditListConfig();
    this.listItems = Object.assign([], this.model.customFields);

    this.unsubscribe.push(subscr3);

    this.setCoverImage();
  }

  private _getCategories(): Observable<SearchResultModel<CategoryModel> | undefined> {
    var search = new CategorySearchModel();
    search.sortColumn = "Name";
    search.sortDirection = "Asc";

    return this.myFileApiService.getDocumentCategories(search);
  }

  setCoverImage(): void {
    if (this.model.coverPhotoFileId == undefined) {
      if (this.model.imageUrl) {
        this.coverImageURL = this.model.imageUrl;
      }
    }
  }

  override ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  override validate(): boolean {
    return true;
  }
  override onUpdate(): void {
    this.model.customFields = this.listItems;
    this.myFileApiService.updateDocumentTemplate(this.model).subscribe(result => {
      this.close();
    })
  }
  override onCreate(): void {
    this.model.customFields = this.listItems;
    this.myFileApiService.createDocumentTemplate(this.model).subscribe(result => {
      this.close();
    })
  }

  onDelete(): void {
    Swal.fire({
      title: $localize`:@@:Delete Document Template`,
      text: $localize`:@@:Are you sure you want to delete this document?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Yes, Delete`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        if (this.model.id) {
          this.myFileApiService.deleteDocumentTemplate(this.model.id).subscribe(result => {
            this.close();
          })
        }
      }
    });
  }

  checkBoolValue(value: string | boolean | undefined): Boolean {
    if (value === undefined) {
      return false;
    }
    if (value === "false" || value === false) {
      return false;
    }
    return true;
  }

  updateCategoryId() {

  }

}
